import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import * as PostApiTypes from '../constants/PostApiTypes';

const deletePost = ({ routes, postId, type, topicId }) => {
  switch (type) {
    case PostApiTypes.TRIP:
      return axios.delete(routes.trip_path(postId));

    case PostApiTypes.EVENT:
      return axios.delete(routes.event_path(postId));

    case PostApiTypes.CHECKIN:
      return axios.delete(routes.checkin_path(postId));

    case PostApiTypes.OPPORTUNITY:
      return axios.delete(routes.business_opportunities_request_path(postId));

    case PostApiTypes.VENTURE:
      return axios.delete(routes.ventures_venture_path(postId));

    case PostApiTypes.POST:
    default:
      return axios.delete(routes.post_path(postId, topicId));
  }
};

export default deletePost;
